<template>
    <div class="printOrderListBox">
        <div class="orderSearchBox">
            <el-date-picker
                v-model="createDateValue"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <el-input v-model="form.demandName" placeholder="需求名称"></el-input>
            <el-input v-model="form.publisher" placeholder="需求方"></el-input>
            <el-select v-model="form.status" placeholder="报价状态">
                <el-option
                    label="已报价"
                    value="OFFERED">
                </el-option>
                <el-option
                    label="已选中"
                    value="CHECKED">
                </el-option>
                <el-option
                    label="未选中"
                    value="UNCHECKED">
                </el-option>
            </el-select>
            <el-button class="searchBtn" @click="search">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="resetData">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>
        </div>
        <div>
            <div class="orderListTable">
                <ul class="tableHeader">
                    <li class="name">需求内容</li>
                    <li class="price">预算</li>
                    <li class="num">报价截止日期</li>
                    <li class="arguments">报价</li>
                    <li class="payment">预计交期</li>
                    <li class="status">报价状态</li>
                    <li class="operation">操作</li>
                </ul>
                <ul class="tableBody" v-if="tableData.length != 0" v-loading="loading">
                    <li class="bodyItem" v-for="(item,index) in tableData" :key="index">
                        <div class="itemTop">
                            <div>创建时间：{{item.createTime}}</div>
                            <div class="merchantInfo">
                                <img :src="item.iconUrl" alt="">
                                <span>{{item.publisher}}</span>
                                <i class="iconfont icon-weixin" @click="startChat(item.publisherUuid)"></i>
                            </div>
                        </div>
                        <div class="itemBottom">
                            <div class="name">
                                <div class="orderInfo">
                                    <div class="orderInfoName">{{item.demandName}}</div>
                                    <div class="infoContent">
                                        {{item.des}}
                                    </div>
                                </div>
                            </div>
                            <div class="price">¥ {{item.money}}</div>
                            <div class="num">{{item.deadline}}</div>
                            <div class="arguments">
                                ¥{{item.offer}}
                            </div>
                            <div class="payment">
                                {{item.planDeliveryTime}}
                            </div>
                            <div class="status">
                                <div class="statusName">{{item.statusCn}}</div>
                            </div>
                            <div class="operation">
                                <el-button type="text" class="operationBtn" @click="toDetails(item)">报价详情</el-button>
                                <el-button type="text" class="operationBtn" v-if="item.status == 'CHECKED'" @click="toOrderDetail(item)">订单详情</el-button>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
                <div class="orderNomesaage" v-loading="loading" v-else >
                     <img src="../../../assets/images/暂无内容.jpg" alt="" style="width:200px">
                </div>
            </div>
            <el-pagination
                v-if="tableData.length != 0"
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>
        </div>
        <el-dialog
            title="查看详情"
            :visible.sync="dialogVisible"
            width="1000px" class="myQuoteDialogBox">
            <div class="myQuoteDialog">
                <div class="left_top">
                    <div class="left_top_title flex">
                        <div class="titleContent">
                            <p class="designTitle">
                                <span class="designTitleContent" v-text="title">教育机构品牌标志设计</span>
                            </p>
                            <div class="budget flex">
                                <div class="flex budgetOne">
                                    <p class="budgetOneP">预算</p>
                                    <p class="budgetOneP2" v-text="money">￥ 50~200</p>
                                </div>
                                <div class="budgetLeft">
                                    <p>发布时间：<span v-text="pudDate">2021-10-18</span></p>
                                </div>
                                <div class="budgetRight">
                                    <p>截止时间：<span v-text="endDate">2021-12-12</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="left_bottom">
                    <p class="left_bottom_title">报价信息</p>
                    <div class="bottom_input">
                        <div class="bottom_money flex">
                            <p class="title">报&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价</p>
                            <p class="content"  v-text="'¥'+offer.offer">100元</p>
                        </div>
                        <div class="bottom_money flex">
                            <p class="title">计划工期</p>
                            <p class="content"  v-text="offer.planDeliveryTime">2021-11-23</p>
                        </div>
                    </div>
                    <div class="bottom_tex flex">
                        <p>报价说明</p>
                        <div v-text="offer.remark">
                            按实际还款案件卡刷点卡案件卡萨丁卡士达阿萨撒大卡的就卡的看
                        </div>
                    </div>
                    <div class="bottom_tex flex">
                        <p>说明文件</p>
                        <ul>
                            <li  v-for="(items, index) in offer.designerAttachmentForDemands"
                                :key="index">
                                <a :href="items.fileUrl" :download="items.fileName" style="color:#157efb">
                                    {{ items.fileName }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 基本信息 -->
                <div class="left_center">
                    <div class="center_mess">
                        <p class="center_mess_title">需求详情</p>
                        <div class="basicInformation">
                            <div class="center_mess_box">
                                <p class="mess_box_title flex"><i></i>需求分类</p>
                                <div class="mess_box_details flex" v-text="demandCate">
                                    <p>设计需求</p>
                                    <i></i>
                                    <p>艺术设计</p>
                                </div>
                            </div>
                            <div class="center_mess_box">
                                <p class="mess_box_title flex"><i></i>期望交期</p>
                                <div class="mess_box_details flex">
                                    <p v-text="expectDate">2021年12月12日</p>
                                </div>
                            </div>

                            <div class="center_mess_box">
                                <p class="mess_box_title flex"><i></i>交付文件类型</p>
                                <div class="mess_box_details flex">
                                    <p v-text="offerType">STL、</p>
                                </div>
                            </div>
                            <div class="center_mess_box">
                                <p class="mess_box_title flex"><i></i>规格尺寸</p>
                                <div class="mess_box_details flex">
                                    <p v-text="size">50*50*50</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center_mess">
                        <p class="center_mess_title">需求描述</p>
                        <div class="center_mess_box">
                            <div class="mess_box_details" >
                                <p v-text="des">
                                    需求描述：我们需要一款LOGO设计；<br />
                                    1.设计风格要求：有中国风感觉的，能体现科技感，需要把传统元素与高端科技相结合。<br />
                                    2.面向80-90后追求高品质生活的人群<br />
                                    3.品牌LOGO形象能够凸显和体现整个品牌特色的气质。<br />
                                </p>
                            </div>
                            <div class="mess_box_details" v-html="demandRemark">
                                <p>
                                    需求描述：我们需要一款LOGO设计；<br />
                                    1.设计风格要求：有中国风感觉的，能体现科技感，需要把传统元素与高端科技相结合。<br />
                                    2.面向80-90后追求高品质生活的人群<br />
                                    3.品牌LOGO形象能够凸显和体现整个品牌特色的气质。<br />
                                </p>
                            </div>
                            <div class="mess_box_text">
                                <p  v-for="(items, index) in demandAttachments"
                                    :key="index">
                                    <a :href="items.fileUrl" :download="items.fileName" style="color:#157efb">
                                        <i class="iconfont icon-xiazai"></i>
                                        {{ items.fileName }}
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="center_mess" style="margin-bottom: 0">
                        <p class="center_mess_title">交易预设</p>
                        <div class="center_mess_box">
                            <p style="padding: 10px 0 0; margin-left: 5px">支付方式</p>
                            <div class="mess_box_details flex">
                                <div class="payIcon">
                                    <div class="payIconContent">￥</div>
                                    <div class="payIconLine"></div>
                                </div>
                                <p>线上支付</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
    </div>
</template>

<script>
import {getOfferOrderList, demandDetail, getRongCloudUser, findAllDesignList} from "../../../utils/interface";
    import {mapState, mapMutations} from "vuex";
    import chatDialog from "../../../components/chat/chatDialog";
    export default {
        data() {
            return {
                createDateValue: null,
                form: {demandName:'',
                    publisher:''
                },
                demandName: '',
                designerName: '',
                demandPerson: '',
                transactionStatus: '',
                evaluateStatus: '',
                tableData: [
                ],
                dialogVisible: false,
                pageNo: 0,
                pageSize: 10,
                total: 1000,
                demand:{},
                offer:{},
                user:{},
                title: null,
                money: null,
                pudDate: null,
                endDate: null,
                restTime: null,
                demandCate:null,
                expectDate:null,
                offerType:null,
                size:null,
                des:null,
                demandRemark:null,
                demandAttachments: [],
            }
        },
        created() {
            this.search();
        },
        components: {
          chatDialog
        },
        methods: {
            resetData() {
                  this.createDateValue = null;
                this.form.demandName = "";
                this.form.designerName = "";
                this.form.publisher = "";
                this.form.status = "";
                this.form.inputDate = "";
            },
            // 分页
            handleCurrentChange(val){
                this.pageNo = val;
                this.search();
            },
            search(){
                this.loading = true
                if(this.createDateValue != null){
                    this.form.inputDate = this.createDateValue.join(" - ");
                }
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                this.form.designerUuid = 1;
                getOfferOrderList(this.form).then((res)=>{
                    this.tableData = [];
                    // console.log(res);
                    if(res != null && res.list != null && res.list.length > 0){
                        this.total = res.total;
                        res.list.forEach((item, index) => {
                            let demand = {};
                            demand = item;
                            demand.money = item.lowPreAmount + " - " + item.highPreAmount;
                            demand.des = item.demandDes;
                            if (item.demandRemark != null && item.demandRemark != undefined) {
                                this.demandRemark=item.demandRemark.replace(/<[^>]+>/g,"").replace(/&nbsp;/gi,'');
                            }
                            this.tableData.push(demand);
                            console.log(this.tableData);
                            this.loading = false
                        });
                    }else{
                        this.total = 0;
                        this.loading = false
                    }
                });
            },
            // 查看
            toDetails(demand) {

                demandDetail(demand.demandUuid).then((res)=>{
                    console.log(res);
                    if(res != null){
                        this.demand = res;
                        this.title = res.demandName;
                        this.money = '￥' + res.lowPreAmount + '~' + res.highPreAmount;
                        this.pudDate=res.publishTime;
                        this.endDate=res.deadline;
                        this.demandCate=res.demandTypeCn;
                        this.expectDate=res.expectedDeliveryTime;
                        this.offerType=res.fileType;
                        if(res.demandType == 'MODEL') {
                            this.size = res.specificationsStart + '~' + res.specificationsEnd + 'cm';
                        // }else{
                            // this.size = '设计需求';
                        }
                        this.des=res.demandDes;
                        if (res.demandRemark != null && res.demandRemark != undefined) {
                            this.demandRemark=res.demandRemark.replace(/<[^>]+>/g,"").replace(/&nbsp;/gi,'');
                        }
                        this.user = res.user;
                        this.demandAttachments = res.demandAttachments;

                        this.offer = demand;
                        this.dialogVisible = true;
                    }
                });

            },
            startChat(targetUuid) {
                let user = this.$store.state.userMessages;
                getRongCloudUser(targetUuid).then(res=> {
                    console.log(res);
                    this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
                });
            },
            // 跳转至详情页
            toOrderDetail(demand){
                let params = {
                    demandUuid:demand.demandUuid,
                };
                findAllDesignList(params).then((res1)=>{
                    if(res1 && res1.length > 0){
                        this.$emit('hompageLog','order')
                        this.$router.push({name:'designOrderDetail',params:{uuid:res1[0].uuid}})
                    }
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .printOrderListBox {
        .flex{
            display: flex;
            align-items: center;
        }
        .orderNomesaage{
           display: flex;
           justify-content: center;
        }
        .titleContent {
            .designTitle {
                margin-top: 0;
                span {
                    font-size: 12px;
                    font-weight: 400;
                    color: #c9c9c9;
                    padding-left: 15px;
                    vertical-align: middle;
                }
                .designTitleContent {
                    font-size: 18px;
                    font-weight: bold;
                    color: #262626;
                    letter-spacing: 1px;
                    padding: 0;
                    max-width: 250px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: inline-block;
                }
            }
            .budget {
                padding: 0;
                font-size: 12px;
                color: #5a5a5a;
                align-items: center;
                display: flex;
                .budgetOne {
                    margin-right: 84px;
                    .budgetOneP {
                        width: 67px;
                        height: 32px;
                        background: #157efb;
                        font-size: 16px;
                        color: #fff;
                        text-align: center;
                        line-height: 32px;
                    }
                    .budgetOneP2 {
                        // width: 113px;
                        padding: 0 5px;
                        height: 32px;
                        line-height: 32px;
                        box-sizing: border-box;
                        border: 1px solid #157efb;
                        font-size: 18px;
                        line-height: 32px;
                        text-align: center;

                        color: #157efb;
                    }
                }
                .budgetLeft {
                    p {
                        margin-right: 21px;
                    }
                }
            }
        }
        .left_top {
            padding: 0 30px;
            margin-bottom: 20px;

            .left_top_title {
                justify-content: space-between;
                border-bottom: 1px solid #efefef;
            }
        }
        .left_center {
            padding: 0 40px 20px 40px;
            border-radius: 10px;
            margin-bottom: 20px;
            .center_mess {
                margin-bottom: 10px;
                .basicInformation {
                    //   display: flex;
                    //   flex-wrap: wrap;
                    .center_mess_box {
                        width: 50%;
                        margin-top: 20px;
                        .mess_box_details {
                            margin-top: 10px;
                            margin-left: 5px;
                        }
                    }
                }
                .center_mess_title {
                    font-size: 18px;
                    color: #262626;
                    font-weight: bold;
                }

                .center_mess_box {
                    .mess_box_title {
                        font-size: 16px;
                        color: #262626;
                        font-weight: bold;
                        align-items: center;

                        i {
                            display: inline-block;
                            width: 2px;
                            height: 16px;
                            background: #157efb;
                            margin-right: 4px;
                            position: relative;
                            //   top: 2px;
                        }
                    }
                    .mess_box_details {
                        align-items: center;
                        margin-top: 15px;
                        margin-left: 5px;

                        p {
                            color: #000;
                            font-size: 14px;
                            line-height: 20px;
                            margin: 0;
                        }

                        i {
                            display: inline-block;
                            width: 1px;
                            height: 16px;
                            background: #555;
                            margin: 0 10px;
                        }
                    }

                    .mess_box_text {
                        color: #157efb;
                        font-size: 14px;
                        margin-top: 15px;
                        margin-left: 5px;

                        p {
                            align-content: center;
                            display: flex;
                            line-height: 20px;
                            i {
                                font-size: 20px;
                            }
                        }
                    }

                    .mess_img {
                        display: flex;
                        align-items: center;
                        margin-top: 14px;
                    }
                }
            }
        }
        .left_bottom {
            font-size: 14px;
            color: #555;
            margin: 0 40px;
            border-bottom: 1px solid #efefef;
            padding-bottom: 10px;
            p {
                color: #000;
                margin: 0;
            }
            .left_bottom_title {
                font-size: 18px;
                font-weight: bold;
                color: #262626;
                padding-bottom: 20px;
            }

            .bottom_input {
                align-items: center;
                .bottom_money {
                    align-items: center;
                    padding-bottom: 10px;
                    .title{
                        padding-right: 20px;
                        min-width: 80px;
                        box-sizing: border-box;
                    }
                }
            }

            .bottom_tex {
                align-items: initial;
                padding-bottom: 10px;
                p {
                    padding-right: 20px;
                    min-width: 80px;
                    box-sizing: border-box;
                    margin: 0;
                }
                div{
                    color: #000;
                }
                ul{
                    li{
                        padding-bottom: 5px;
                        color: #157efb;
                        cursor: pointer;
                    }
                }
            }
        }
        .payIcon {
            width: 39px;
            height: 39px;
            background: #ecf5ff;
            border-radius: 10px;
            margin-right: 10px;
            .payIconContent {
                width: 24px;
                height: 19px;
                color: #fff;
                background: #157efb;
                border-radius: 4px;
                margin: 8px auto 5px;
                font-size: 12px;
                text-align: center;
                line-height: 20px;
            }
            .payIconLine {
                width: 26px;
                height: 1px;
                background: #157efb;
                margin: 0 auto;
            }
        }
        .red {
            color: #d60000;
        }
        padding: 20px 20px 20px;
        .orderListTabs{
            position: absolute;
            left: 0;
            top: 0;
            z-index: 999;
            background: #fff;
            width: 100%;
            padding: 20px;
        }
        /deep/ .el-tabs__item {
            padding: 0 25px !important;
            text-align: center;

            &:hover {
                color: #3686d7
            }

            &:after {
                content: "";
                position: absolute;
                right: 0;
                bottom: 12px;
                width: 1px;
                height: 15px;
                background-color: #E4E7ED;
                z-index: 1;
            }

            &:last-child:after {
                content: "";
                width: 0;
                height: 0;
            }
        }

        /deep/ .el-tabs__active-bar {
            height: 3px;
            background-color: #3686d7;
        }

        /deep/ .el-tabs__item.is-active {
            color: #3686d7
        }

        /deep/ .el-tabs__nav-wrap::after {
            height: 1px;
        }

        .orderSearchBox {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }
            /deep/.el-date-editor{
                width: 480px;
                margin-right: 30px;
                /deep/.el-range-input{
                    background-color: #f2f4f7;
                }
                /deep/.el-range__close-icon{
                    line-height: 28px;
                }
                /deep/.el-range__icon{
                    line-height: 28px;
                }
                /deep/.el-range-separator{
                    line-height: 28px;
                }
                &:hover{
                    /deep/.el-range-input{
                        background-color: #fff;
                    }
                }
            }
            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }

        .orderListTable {
            min-width: 1400px;
            .tableHeader {
                display: flex;
                width: 100%;
                height: 35px;
                line-height: 35px;
                background: #f3f7ff;
                border-radius: 5px;
                margin: 0 0 15px;
                li {
                    text-align: center;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }
            }

            .tableBody {
                li {
                    width: 100%;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;
                    margin-bottom: 15px;
                    .itemTop {
                        width: 100%;
                        height: 42px;
                        background: #ebf3fb;
                        line-height: 42px;
                        font-size: 14px;
                        color: #333;
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        position: relative;

                        div {
                            margin-right: 30px;
                        }

                        .merchantInfo {
                            display: flex;
                            align-items: center;

                            i {
                                color: #3d7fff;
                                font-size: 25px;
                                cursor: pointer;
                                padding-left: 10px;
                                display: block;
                            }

                            img {
                                width: 24px;
                                height: 24px;
                                border-radius: 50%;
                                display: block;
                                margin-right: 10px;
                            }
                        }

                        .complainBtn {
                            color: #999;
                            position: absolute;
                            right: 20px;
                        }
                    }

                    .itemBottom {
                        display: flex;
                        align-items: center;
                        color: #333;
                        font-size: 13px;

                        .orderInfo {
                            padding: 20px;
                            .orderInfoName{
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                            }
                            .infoContent {
                                font-size: 13px;
                                color: #999999;
                                line-height: 22px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .arguments {
                            text-align: center;
                        }
                        .payment {
                            h3 {
                                font-size: 14px;
                                font-weight: 700;
                                margin: 0;
                            }

                            .title {
                                font-size: 12px;
                                color: #999999;
                            }
                        }
                        .status{
                            font-size: 14px;
                        }
                        .operation{
                            padding: 0;
                        }
                        .operationBtn{
                            color: #0c75d3;
                            padding: 6px 20px;
                            border: 1px solid #0c75d3;
                            border-radius: 6px;
                            margin-left: 10px;
                            margin-top: 12px;
                            &:nth-last-of-type(1) {
                                margin-bottom: 12px;
                            }
                        }
                    }
                }
            }

            .name {
                flex: 1;
            }

            .price {
                width: 170px;
                text-align: center;
            }

            .num {
                width: 200px;
                text-align: center;
            }

            .arguments {
                width: 170px;
            }

            .payment {
                width: 180px;
                text-align: center;
            }

            .status {
                width: 200px;
                text-align: center;
            }

            .operation {
                width: 180px;
                text-align: center;
                .operationUploadBtn{
                    width: 102px !important;
                    height: 34px;
                    padding: 0;
                    line-height: 34px;
                    text-align: center;
                    font-weight: 700;
                    color: rgba(0, 102, 204, 0.8);
                    font-size: 14px;
                    border-color: rgba(0, 102, 204, 0.8);
                    display: block;
                    margin: 0 auto 10px !important;
                }
            }
        }
        .pagination {
            margin-top: 20px;
            text-align: right;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/myQuoteList.vue